export interface Author {
  name: string;
  role: string;
  bio: string;
  longBio: string;
  image: string;
  credentials: string[];
  social: {
    twitter?: string;
    instagram?: string;
    linkedin?: string;
  };
  articleCount: number;
}

export const authors: Record<string, Author> = {
  'Sophia Lane': {
    name: 'Sophia Lane',
    role: 'Relationship Writer & Certified Life Coach',
    bio: 'Sophia writes about love, self-worth, and the emotional architecture of healthy relationships. Her work draws on 8 years of coaching practice and a deep belief that self-awareness is the foundation of every great partnership.',
    longBio: 'Sophia Lane is a certified life coach and relationship writer based in London. With over eight years of experience working with individuals and couples, she specialises in attachment theory, emotional intelligence, and the psychology of modern dating. Her writing has helped thousands of readers navigate heartbreak, build healthier patterns, and find the confidence to love fully.',
    image: 'https://public.readdy.ai/ai/img_res/2d447072a1926664f6c47d4e4f0e122f.jpg',
    credentials: ['Certified Life Coach (ICF)', 'BA Psychology, University of Edinburgh', '8+ years coaching practice'],
    social: {
      twitter: '#',
      instagram: '#',
    },
    articleCount: 16,
  },
  'Marcus Reid': {
    name: 'Marcus Reid',
    role: 'Relationship Columnist & Couples Therapist',
    bio: 'Marcus is a couples therapist and writer who believes that most relationship problems are communication problems in disguise. He brings clinical insight and genuine warmth to every piece he writes.',
    longBio: 'Marcus Reid is a licensed couples therapist and relationship columnist with a decade of clinical experience. He trained in Gottman Method Couples Therapy and Emotionally Focused Therapy (EFT), and now splits his time between his private practice and writing for roameurope.blog. Marcus is known for making complex psychological concepts feel immediately practical and human.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20confident%20man%20in%20his%2030s%20warm%20approachable%20smile%20natural%20light%20soft%20neutral%20background%20editorial%20portrait%20clean&width=200&height=200&seq=author-marcus&orientation=squarish',
    credentials: ['Licensed Couples Therapist', 'Gottman Method Level 2 Certified', 'MA Counselling Psychology'],
    social: {
      twitter: '#',
      linkedin: '#',
    },
    articleCount: 14,
  },
  'Priya Nair': {
    name: 'Priya Nair',
    role: 'Dating & Self-Love Writer',
    bio: 'Priya writes at the intersection of culture, identity, and modern romance. She explores how background, family expectations, and self-worth shape the way we love — and how to reclaim that narrative on your own terms.',
    longBio: 'Priya Nair is a writer and researcher specialising in cross-cultural relationships, self-compassion, and the psychology of self-worth in dating. Born in Mumbai and raised across three continents, she brings a globally-minded perspective to the complexities of modern love. Her work has resonated widely with readers navigating identity, independence, and intimacy in a fast-changing world.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20young%20woman%20in%20her%20late%2020s%20South%20Asian%20warm%20confident%20smile%20soft%20natural%20studio%20light%20clean%20minimal%20background%20editorial%20portrait&width=200&height=200&seq=author-priya&orientation=squarish',
    credentials: ['MSc Social Psychology', 'Certified Mindfulness Practitioner', 'Research background in relationship satisfaction'],
    social: {
      twitter: '#',
      instagram: '#',
    },
    articleCount: 11,
  },
};

export const authorList: Author[] = Object.values(authors);
